import { Text } from '@mantine/core';
import { IconTargetArrow } from '@tabler/icons-react';
import type { AIMessage } from '~/common/vm/protocol';
import { CollapsibleCard } from '../CollapsibleCard';

export function AIDecisionCard({ message }: { message: Extract<AIMessage, { type: 'decision' }> }) {
  return (
    <CollapsibleCard
      icon={IconTargetArrow}
      title="Decision"
      defaultExpanded={true}
      classNames={{
        icon: 'text-gray-500 dark:text-gray-400',
      }}
    >
      <div>
        <Text
          size="sm"
          className="leading-relaxed"
        >
          {message.content}
        </Text>
      </div>
    </CollapsibleCard>
  );
}
